module.exports = __webpack_public_path__ + "static/img/eye_detail.8a30d683.png";